module.exports = __webpack_public_path__ + "static/whistle-5fb85db816107cc050170358cfa9a894.png";